import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/data-retention")({
  head: () => ({
    meta: [
      { title: "ClaimGuard | Data Retention Policy" },
      {
        name: "description",
        content:
          "How long ClaimGuard keeps your account data, uploaded invoices, and reports.",
      },
      { property: "og:title", content: "ClaimGuard | Data Retention Policy" },
      {
        property: "og:description",
        content: "How long we retain account data, invoices, and reports.",
      },
      { name: "robots", content: "index,follow" },
      { property: "og:url", content: "https://smart-invoice-ally.lovable.app/data-retention" },
    ],
    links: [{ rel: "canonical", href: "https://smart-invoice-ally.lovable.app/data-retention" }],
  }),
  component: DataRetentionPage,
});

function DataRetentionPage() {
  return (
    <LegalPage
      eyebrow="Data"
      title="Data Retention Policy"
      updated="July 5, 2026"
      intro="This policy describes how long ClaimGuard retains different categories of data and how you can request deletion."
      sections={[
        {
          heading: "Active accounts",
          body: (
            <p>
              While your account is active, we retain your profile, submitted invoices,
              generated reports, negotiation records, and billing history so you can
              access and manage your cases.
            </p>
          ),
        },
        {
          heading: "Closed accounts",
          body: (
            <p>
              When you close your account, we delete account-identifiable data within 90
              days, except for records we are required to retain for legal, tax, or fraud
              prevention purposes (typically up to 7 years for billing records).
            </p>
          ),
        },
        {
          heading: "Uploaded invoices and reports",
          body: (
            <p>
              Uploaded invoices and generated reports are retained for the life of the
              associated case. You may request deletion of a specific case at any time by
              contacting support.
            </p>
          ),
        },
        {
          heading: "Support communications",
          body: (
            <p>
              Support tickets and emails are retained for up to 3 years so we can respond
              to follow-up questions and improve customer service.
            </p>
          ),
        },
        {
          heading: "Analytics and diagnostics",
          body: (
            <p>
              Aggregate, non-identifying analytics and error diagnostics are retained on
              standard schedules from our providers, typically no longer than 24 months.
            </p>
          ),
        },
        {
          heading: "Requesting deletion",
          body: (
            <p>
              To request deletion of your account or a specific case, email{" "}
              <a className="text-trust underline" href="mailto:privacy@invoiceintelligence.com">
                privacy@invoiceintelligence.com
              </a>
              .
            </p>
          ),
        },
      ]}
    />
  );
}
